import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import Select, { components } from 'react-select';
import AdminMaster from "../../../Layout/admin/Master";
import { useMemo } from "react";
import { Form, OverlayTrigger, Stack, Toast, ToastContainer } from "react-bootstrap";
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import { FaRegEye, FaSpinner } from 'react-icons/fa';
import SweetAlert from "react-bootstrap-sweetalert";
import { TextField, Tooltip } from '@mui/material';
import queueDatatableCustomStyles from "../../../Layout/Elements/QueueDatatableCustomStyles";
import { DateRangePicker } from "rsuite";
import { addDays, addMonths, endOfMonth, endOfWeek, endOfYear, setHours, setMinutes, setSeconds, startOfMonth, startOfWeek, startOfYear, subDays } from "date-fns";
import ClientDropDown from "../../common/PartnerClientFacilityDropDown/ClientDropDown";
import FilterComponent from "../../common/FilterComponent";
import useFilter from "../../../hooks/useFilter";
import PartnerDropDown from "../../common/PartnerClientFacilityDropDown/PartnerDropDown";
import { BiExport } from "react-icons/bi";
import TableHeadings from "../../common/TableHeadings";
import * as Yup from 'yup';
import { get837LockBoxList } from "../../../Redux/837LockBox/action";
import { reject837LockBox } from "../../../Redux/837LockBox/action";
import { downloadFile } from "../Dashboard/functions";
import moment from "moment";


const predefinedBottomRanges = [
    {
        label: 'Today',
        value: [new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)],
        placement: 'left'
    },
    {
        label: 'Yesterday',
        value: [addDays(new Date().setHours(0, 0, 0, 0), -1), addDays(new Date().setHours(23, 59, 59, 59), -1)],
        placement: 'left'
    },
    {
        label: 'This week',
        value: [startOfWeek(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 7 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 6), new Date()],
        placement: 'left'
    },
    {
        label: 'Last 30 days',
        value: [subDays(new Date().setHours(0, 0, 0, 0), 29), new Date()],
        placement: 'left'
    },
    {
        label: 'This month',
        value: [startOfMonth(new Date().setHours(0, 0, 0, 0)), new Date()],
        placement: 'left'
    },
    {
        label: 'Last month',
        value: [startOfMonth(addMonths(new Date().setHours(0, 0, 0, 0), -1)), endOfMonth(addMonths(new Date(), -1))],
        placement: 'left'
    },
    {
        label: 'This year',
        value: [new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0), new Date()],
        placement: 'left'
    },
    {
        label: 'Last year',
        value: [setSeconds(setMinutes(setHours(startOfYear(new Date(new Date().getFullYear() - 1, 0, 1)), 0), 0), 0), setSeconds(setMinutes(setHours(endOfYear(new Date(new Date().getFullYear(), 0, 0)), 23), 59), 59)],
        placement: 'left'
    },

    {
        label: 'Last week',
        closeOverlay: false,
        value: value => {
            const [start = new Date().setHours(0, 0, 0, 0)] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), -7)
            ];
        },
        appearance: 'default'
    },
    {
        label: 'Next week',
        closeOverlay: false,
        value: value => {
            const [start = new Date()] = value || [];
            return [
                addDays(startOfWeek(start, { weekStartsOn: 0 }), 7),
                addDays(endOfWeek(start, { weekStartsOn: 0 }), 7)
            ];
        },
        appearance: 'default'
    }
];




const fileTypeFilter = [
    { value: '1', label: '837' },
    { value: '2', label: 'Self Pay' },
]

const statusFilter = [
    { value: 'COMPLETED', label: 'COMPLETED' },
    { value: 'IN_PROGRESS', label: 'INPROGRESS' },
    { value: 'REJECTED', label: 'REJECTED' }

]
const List837LockBox = (params) => {

    const [loader, setLoader] = useState({
        id: null,
        type: null
    });
    const filterValidationSchema = Yup.object().shape({

        // Only required (no type or length check)
        // recieved_date_range: Yup.mixed().required('Date range is required')
    })

    const [colorRow, setColorRow] = useState({});
    const [toaster, setToaster] = useState('')
    const [isLoadingPartners, setIsLoadingPartners] = useState(false);
    const [isFocusedPartner, setIsFocusedPartner] = useState(false);

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>
                {isLoadingPartners ? (
                    <FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
                ) : searchFormik.values?.[state]?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };

    const handleRowCheckClick = (row) => {
        data?.results?.data?.map((item, index) => {
            if (row?.id == item.id) {
                setColorRow(row)
            }
        })
    };


    const handleDblClickCopy = async (filename) => {
        navigator.clipboard.writeText(filename)
    };




    const initialFilters = useMemo(() => ({
        partner: [],
        client: [],
        upload_date_range: '',
        received_date_range: '',
        status: [],
        file_type: "",
        file_name: ""
    }), []);

    const {
        searchFormik,
        handleReset,
        handleSearch,
        handleChange,
        data, loading, pageNo, limit, totalRows, searchKeyForTable,
        fetchData, handlePageChange, handlePerRowsChange, setSearchedData, setData,
        setSearchKeyForTable,
    } = useFilter(initialFilters, get837LockBoxList, filterValidationSchema);


    const handleOnDateTimeChange = ({ name, value }) => {
        // Force start time to 00:00:00 and end time to 23:59:00
        let adjustedValue = value;
        if (value && value.length === 2) {
            const startDate = new Date(value[0]);
            startDate.setHours(0, 0, 0, 0);

            const endDate = new Date(value[1]);
            endDate.setHours(23, 59, 0, 0);

            adjustedValue = [startDate, endDate];
        }

        searchFormik.setValues({
            ...searchFormik.values,
            [name]: adjustedValue ?? "", // Store adjusted date range
        });
    };



    const viewTiff = (file) => {
        setUrlsplitedfile(file)
        setShowCheckView(true)
    }

    const defaultColumns = {
        'S.NO': true,
        'Partner': true,
        'Client': true,
        'FILE NAME': true,
        'Created User': true,
        'FILE STATUS': true,
        'FILE TYPE': true,
        'FILE SIZE': true,
        'FILE COUNT': true,
        'FILE UPLOAD DATE & TIME': false,
        'RECEIVED DATE & TIME': true,
        'FILE RECEIVED': true,
        'REJECT REASON': true,
        'ACTION': true,
    };

    const [state, setState] = useState(defaultColumns);
    const [columnOrder, setColumnOrder] = useState(() => {
        const saved = localStorage.getItem('837_lockbox_column_order');
        return saved ? JSON.parse(saved) : [];
    });

    const handleColumnOrderChange = (newOrder) => {
        const orderIds = newOrder.map(col => col.id);
        setColumnOrder(orderIds);
        localStorage.setItem('837_lockbox_column_order', JSON.stringify(orderIds));
    };
    const checkUserPermission = (check) => {
        var permissions = JSON.parse(localStorage.getItem('permissions'))
        var data = permissions.find((element) => {
            return element == check;
        })
        if (data && data != undefined) {
            return true;
        }
        else {

            return false;
        }
    }
    const columns = useMemo(
        () => {
            const baseColumns = [


                {
                    id: 's_no',
                    name: 'S.NO',
                    selector: (row, index) => pageNo == 1 ? index + 1 : (pageNo - 1) * limit + index + 1,
                    width: "60px",
                    wrap: true,
                    omit: !state?.['S.NO']

                },


                {
                    id: 'partner',
                    name: 'Partner',
                    selector: row => row?.partner,
                    cell: (row) =>


                        <div className="overflow-hidden d-flex flex-row  flex-wrap text-truncate " onClick={() => handleRowClick(row)} style={{ width: "140px" }}>
                            <Tooltip disableInteractive title={row?.partner} placement='top' arrow>

                                {row?.partner &&
                                    <span className='text-truncate' onDoubleClick={() => handleDblClickCopy(row?.partner)}>{row?.partner}</span>
                                }
                            </Tooltip>
                        </div>



                    ,
                    sortable: true,
                    left: true,
                    wrap: true,
                    width: '160px',
                    reorder: true,
                    exportKey: 'PARTNER',
                    omit: !state?.['Partner']
                },

                {
                    id: 'client_name',
                    name: 'Client',
                    selector: row => row?.client_name,
                    cell: (row) =>


                        <div className="overflow-hidden d-flex flex-row  flex-wrap text-truncate " onClick={() => handleRowClick(row)} style={{ width: "140px" }}>
                            <Tooltip disableInteractive title={row?.client_name} placement='top' arrow>

                                <span className='text-truncate' onDoubleClick={() => handleDblClickCopy(row?.client)}>{row?.client_name}</span>
                            </Tooltip>
                        </div>
                    ,
                    sortable: true,
                    left: true,
                    wrap: true,
                    width: '160px',
                    reorder: true,
                    exportKey: 'CLIENT NAME',
                    omit: !state?.['Client']
                },




                {
                    id: 'file_name',
                    name: 'FILE NAME',
                    selector: row => row?.file_name,
                    cell: (row) => <div>
                        {row?.file_name &&
                            <div className='d-flex flex-row justify-content-between align-items-center gap-2' onClick={() => handleRowClick(row)} style={{ width: '150px' }}>
                                <div className='overflow-hidden d-flex flex-row  flex-wrap text-truncate' style={{ width: "100%" }} onDoubleClick={() => handleDblClickCopy(row?.file_name)} >
                                    <Tooltip disableInteractive title={row?.file_name} placement='top' arrow>
                                        <span className='text-truncate'> {row?.file_name}</span>
                                    </Tooltip>
                                </div>
                                {row?.converted_file != "" && loader?.jobFileName?.includes(row?.file_id) ? spinner :
                                    <div role="button" onClick={() => (row?.converted_file)} className=''>
                                        {/* <FaRegEye /> */}
                                    </div>
                                }
                            </div>
                        }
                    </div>
                    ,
                    sortable: true,
                    width: '160px',
                    reorder: true,
                    left: true,
                    wrap: true,
                    // grow: 0.2,
                    exportKey: 'FILE NAME',
                    omit: !state?.['FILE NAME']
                },



                {
                    id: 'created_by',
                    name: 'Created User',
                    selector: row => row?.created_by,
                    cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.created_by}</span>,
                    sortable: true,
                    // right: true,
                    wrap: true,
                    reorder: true,
                    exportKey: 'CREATED BY',
                    omit: !state?.['Created User'],
                    width: '160px',
                },


                {
                    id: 'file_status',
                    name: 'FILE STATUS',
                    selector: row => row?.file_status,
                    cell: (row) => <span onClick={() => handleRowClick(row)}  > {row?.file_status}</span>,
                    // sortable: true, this is commented manually because of 837 module has not sort option   by backend
                    left: true,
                    wrap: true,
                    reorder: true,
                    exportKey: 'FILE STATUS',
                    omit: !state?.['FILE STATUS'],
                    width: '110px',
                },
                {
                    id: 'file_type',
                    name: 'FILE TYPE',
                    selector: row => row?.file_type,
                    cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_type}</span>,
                    // sortable: true, this is commented manually because of 837 module has not sort option   by backend
                    left: true, 
                    wrap: true,
                    reorder: true,
                    exportKey: 'FILE TYPE',
                    omit: !state?.['FILE TYPE'],
                    width: '110px',
                },


                {
                    id: 'file_size',
                    name: 'FILE SIZE',
                    selector: row => row?.file_size,
                    cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_size}</span>,
                    // sortable: true, this is commented manually because of 837 module has not sort option   by backend
                    left: true,
                    wrap: true,
                    reorder: true,
                    exportKey: 'FILE SIZE',
                    omit: !state?.['FILE SIZE'],
                    width: '110px',
                },
                {
                    id: 'file_count',
                    name: 'FILE COUNT',
                    selector: row => row?.file_count,
                    cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.file_count}</span>,
                    // sortable: true, this is commented manually because of 837 module has not sort option  by backend
                    left: true,
                    wrap: true,
                    reorder: true,
                    exportKey: 'FILE COUNT',
                    omit: !state?.['FILE COUNT'],
                    width: '110px',
                },


                {
                    id: 'upload_date',
                    name: 'FILE UPLOAD DATE & TIME ',
                    selector: row => row.upload_date,
                    cell: (row) => <div onClick={() => handleRowClick(row)}>
                        {row.upload_date}
                    </div>,
                    sortable: true,
                    reorder: true,
                    left: true,
                    minWidth: "150px",
                    wrap: true,
                    exportKey: 'FILE UPLOAD DATE & TIME',
                    omit: !state?.['FILE UPLOAD DATE & TIME']
                },

                  {
                    id: 'received_date',
                    name: 'RECEIVED DATE & TIME',
                    selector: row => row.received_date,
                    cell: (row) => <div onClick={() => handleRowClick(row)}>
                        {row.received_date}
                    </div>,
                    sortable: true,
                    reorder: true,
                    left: true,
                    minWidth: "150px",
                    wrap: true,
                    exportKey: 'RECEIVED DATE & TIME',
                    // omit: !state?.['RECEIVED DATE & TIME']
                },
                {
                    id: 'reject_reason',
                    name: 'REJECT REASON',
                    selector: row => row?.reject_reason,
                    cell: (row) => <span onClick={() => handleRowClick(row)}> {row?.reject_reason}</span>,
                    sortable: true,
                    left: true,
                    wrap: true,
                    reorder: true,
                    exportKey: 'REJECT REASON',
                    omit: !state?.['REJECT REASON'],
                    width: '110px',
                },
                {
                    id: 'action',
                    name: 'ACTION',
                    omit: !state?.['ACTION'],
                    selector: row => <div onClick={() => handleRowClick(row)} className="d-flex justify-content-end flex-shrink-0 align-items-center">
                        <React.Fragment>
                            <div className="ms-1" role="button" >
                                <i className='bi bi-download' onClick={() => downloadFile(row?.file, row?.file_name)} />
                            </div>
                        </React.Fragment>
                        {checkUserPermission('reject_incomplete_837_lockbox') &&
                            <React.Fragment>
                                <div style={{ visibility: ['IN_PROGRESS', 'INCOMPLETE']?.includes(row?.file_status) ? 'visible' : 'hidden' }} className="btn fs-7 fw-bold btn-sm" role="button" onClick={() => {
                                    setIsSwal({ show: true, id: row?.id, data: row });
                                    setRejectText("");
                                    setRejectReason("");
                                    setErrorMessage(false);
                                }}>
                                    <span className="text-style-icon">
                                        Reject
                                    </span>
                                </div>
                            </React.Fragment>
                        }
                    </div>,
                    wrap: true,
                    width: '100px',
                },

            ];

            if (!columnOrder || columnOrder.length === 0) {
                return baseColumns;
            }

            const colMap = baseColumns.reduce((acc, col) => {
                acc[col.id] = col;
                return acc;
            }, {});

            const ordered = columnOrder.map(id => colMap[id]).filter(Boolean);
            const missing = baseColumns.filter(col => !columnOrder.includes(col.id));

            return [...ordered, ...missing];
        },
        [loader, state, pageNo, data, limit, columnOrder],
    );

    useEffect(() => {
        localStorage.setItem("lockbox_table_columns", JSON.stringify(state));
    }, [state]);

    useEffect(() => {
        const savedState = localStorage.getItem("lockbox_table_columns");
        if (savedState) {
            const parsed = JSON.parse(savedState);
            setState(prevState => ({ ...prevState, ...parsed }));
        }
    }, []);




    const DateRangePickerComponent = (props) => {
        const {
            tooltip,
            value,
            name,
            handleChange,
            className = 'form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker',
            placeholder = "MM/DD/YYYY - MM/DD/YYYY",
            format = 'MM/dd/yyyy',
            error,
            touched,
        } = props
        const hasError = touched && error;






        return (
            < >
                {/* <Tooltip title={tooltip} placement="top" disableInteractive>

                    <Stack direction="column" spacing={8} alignItems="flex-start"
                    style={{ maxWidth: '230px', width: '100%' }}>
                        <DateRangePicker
                            ranges={predefinedBottomRanges}
                            cleanable
                            placement="auto"
                            appearance="default"
                            format={format}
                            placeholder={placeholder}
                            className={`jobmonitor-datepicker ${hasError ? 'error-border' : ''}`}
                            name={name}
                            onChange={val => handleChange(name, val)}
                            value={value}
                            
                        />
                        
                    </Stack>
                </Tooltip> */}


               






                <Tooltip title="File Upload Date" placement="top" disableInteractive>

                    <Stack direction="column" spacing={8} alignItems="flex-start">
                        <DateRangePicker
                            ranges={predefinedBottomRanges}
                            // style={{ backgroundColor: "#000" }}
                            cleanable={true}
                            placement='auto'
                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                            appearance="default"
                            format={"MM/dd/yyyy HH:mm"}
                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                            name="upload_date_range"
                            value={searchFormik.values.upload_date_range||null}
                            onChange={(value) => handleOnDateTimeChange({ name: "upload_date_range", value, })
                            }

                        />
                    </Stack>
                </Tooltip>


            </>
        )
    }

    const [ToastMessage, setToastMessage] = useState({
        status: false,
        message: "",
        type: "",
    })
    const [isSwal, setIsSwal] = useState({
        show: false,
        id: '',
        data: '',
    })
    const [isSwalmessage, setIsSwalmessage] = useState({
        status: false,
        message: "",
    })
    const [rejectText, setRejectText] = useState("");
    const [errorMessage, setErrorMessage] = useState(false);
    const [rejectReason, setRejectReason] = useState("");

    var i = 0;
    const conditionalRowStyles = [

        {
            when: row => { i = i + 1; return i % 2 == 0 || colorRow.id == row.id ? true : false },
            style: (row, index) => ({
                backgroundColor: colorRow?.id == row?.id ? '#dbf4f5' : '#f2f2f2',
            }),
        },

    ];



    const handleRowClick = (row) => {
        setColorRow(row);
    };

    const [exportLoader, setExportLoader] = useState(false)
    const handleExport = () => {
        // Construct header_names based on current columns order and visibility
        let header_names = columns
            ?.filter(item => (!item.omit && (item?.exportKey != undefined)))         // keep only items where omit = false and has exportKey
            .map(item => item?.exportKey)         // pick the exportKey
            .join(',');


        setExportLoader(true)
        get837LockBoxList(pageNo, limit, searchFormik?.values, true, header_names)(response => {
            if (response?.status) {
                downloadFile(response?.data, `837-LockBox`)
            }
            setExportLoader(false)
        })
    }

    const handleSelectChange = (e) => {

        searchFormik.setFieldValue('status', e)
    }

    const handleCustomReset = () => {
        searchFormik.resetForm();
        setSearchedData(initialFilters);
        setData([])
        setColumnOrder([]);
        localStorage.removeItem('837_lockbox_column_order');
        fetchData(1, limit, initialFilters);
        setSearchKeyForTable(prev => !prev);
    }

    const handleSort = (column, sortDirection) => {

        fetchData(pageNo, limit, { ...searchFormik.values, sort_order: sortDirection, sort_key: column?.id });
    };

    const handleReject837LockBox = (pk) => {
        if (rejectText === "Delete") {
            if (!rejectReason || rejectReason.trim() === "") {
                setErrorMessage(true);
                return;
            }

            reject837LockBox(pk, rejectReason)((response) => {
                setIsSwal({ show: false });
                setRejectText("");
                setRejectReason("");
                if (response.status) {
                    setToaster('success');
                    const timer = setTimeout(() => {
                        setToaster(false);
                    }, 2000);
                    fetchData(pageNo, limit, searchFormik.values);
                    return () => clearTimeout(timer);
                } else {
                    setToastMessage({
                        status: true,
                        message: response?.response?.data?.errors || "Failed to reject file",
                        type: 'danger',
                    });
                    const timer = setTimeout(() => {
                        setToastMessage({
                            status: false,
                            message: "",
                            type: "",
                        });
                    }, 2000);
                    fetchData(pageNo, limit, searchFormik.values);
                }
            });
        } else {
            setErrorMessage(true);
        }
    };


    return (
        <React.Fragment>
            <AdminMaster ToastMessage={toaster} />
            <ToastContainer className="p-3" position={"top-end"}>
                <Toast bg={ToastMessage?.type} onClose={() => setToastMessage(
                    {
                        status: false,
                        message: "",
                        type: "",
                    }

                )}
                    show={ToastMessage?.status} animation={true} delay={2000} autohide>
                    <Toast.Body ><span className='text-white'>{ToastMessage?.message}</span></Toast.Body>
                </Toast>

            </ToastContainer>


            {isSwalmessage.status === true &&
                <SweetAlert
                    danger

                    confirmBtnText="Ok!"
                    //confirmBtnBsStyle="danger"
                    confirmBtnCssClass="custom-confirm-button-class"
                    onConfirm={() => { setIsSwalmessage({ ...isSwalmessage, status: false, message: "" }) }}
                >
                    <span className="fw-bold ">  {isSwalmessage.message}</span>
                </SweetAlert>}

            {isSwal.show === true &&
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Reject!"
                    confirmBtnCssClass="custom-confirm-button-class"
                    cancelBtnCssClass="custom-cancel-button-class"
                    title="Are you sure?"
                    onConfirm={() => { handleReject837LockBox(isSwal.id) }}
                    onCancel={() => {
                        setIsSwal({ ...isSwal, show: false });
                        setRejectText("");
                        setRejectReason("");
                        setErrorMessage(false);
                    }}
                    focusCancelBtn
                >
                    <div className='user-select-none'>

                        <p>
                            Reject action can't be reverted back.
                        </p>

                        <br />

                        <p className='my-1 fw-bold'>Type <span className='text-danger'>"Delete"</span> to Reject  <br /><span className='color-xtract'>{isSwal.data?.file_name}</span></p>

                        <Form.Control
                            onChange={(e) => {
                                setRejectText(e.target.value);
                                setErrorMessage(false);
                            }}
                            type="text"
                            placeholder="Type 'Delete' to confirm"
                            className={errorMessage ? "form-control-solid text-center b-r-10 my-3 border-danger" : 'form-control-solid text-center b-r-10 my-3'}
                        />

                        <p className='my-1 fw-bold'>Reject Reason</p>

                        <Form.Control
                            onChange={(e) => {
                                setRejectReason(e.target.value);
                                setErrorMessage(false);
                            }}
                            placeholder="Enter reject reason"
                            className={errorMessage && !rejectReason ? "form-control-solid b-r-10 my-3 border-danger" : 'form-control-solid b-r-10 my-3'}
                        />

                    </div>

                </SweetAlert>
            }

            <main id="main" className="main">

                <div className="pagetitle tab-fixed-header">
                    <h1 id='page-title'>837 LockBox</h1>
                </div>

                <section className="section mt-5">
                    <div className="row align-items-top   gap-2 gap-md-5">
                        <div className="col-lg-12">
                            <div className="card mb-5 mb-xl-8">
                                <div className='card-header'>
                                    <div className="d-flex align-items-center  position-relative ms-4">
                                        <FilterComponent
                                            formik={searchFormik}
                                            onReset={handleCustomReset}
                                            extraAction={
                                                <div className="d-flex" >
                                                    <div className="me-2">

                                                        <TableHeadings
                                                            columnState={state}
                                                            setColumnState={setState}
                                                        />
                                                    </div>
                                                    <button onClick={handleExport} className="btn btn-light btn-active-primary pb-2  jobMonitor-Buttons" type="button"  >
                                                        {exportLoader ? (
                                                            <>
                                                                <span
                                                                    className="spinner-border spinner-border-sm me-1"
                                                                    role="status"
                                                                    aria-hidden="true"
                                                                ></span>

                                                            </>
                                                        ) : (
                                                            <>
                                                                <BiExport className="me-1" />

                                                            </>
                                                        )}

                                                    </button>
                                                </div>
                                            }
                                        >
                                            <TextField
                                                id="file_name"
                                                name="file_name"
                                                type="search"
                                                placeholder="Filename"
                                                value={searchFormik.values.file_name || ""}
                                                onChange={searchFormik.handleChange}
                                                onBlur={() => searchFormik.setFieldTouched("search", true)}
                                                sx={{
                                                    width: "250px",
                                                    "& .MuiOutlinedInput-root": {
                                                        backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                        borderRadius: "10px",
                                                        height: "40px",
                                                        paddingRight: 0,
                                                        border: "none",
                                                        boxShadow: "none",
                                                        "& fieldset": {
                                                            border: "none",
                                                        },
                                                    },
                                                    "& .MuiOutlinedInput-input": {
                                                        padding: "10px 12px",
                                                        fontSize: "15px",
                                                    },
                                                }}
                                            />


                                            <PartnerDropDown lockboxformik={searchFormik} name="partner" />
                                            <ClientDropDown lockboxformik={searchFormik} name="client" />
                                            <Select
                                                isMulti
                                                className="basic-single select-search-facility"
                                                classNamePrefix="select"
                                                tabSelectsValue={false}
                                                closeMenuOnSelect={""}
                                                value={searchFormik.values?.status}
                                                name="status"
                                                components={{
                                                    DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
                                                }}
                                                options={statusFilter}
                                                onFocus={() => setIsFocusedPartner(true)}
                                                onBlur={() => setIsFocusedPartner(false)}
                                                onChange={handleSelectChange}
                                                placeholder="Select Status"
                                                styles={{
                                                    container: (styles) => ({
                                                        ...styles,
                                                        borderRadius: "9px",
                                                        width: '250px',
                                                    }),
                                                    placeholder: (styles) => ({
                                                        ...styles,
                                                        fontSize: '17px'
                                                    }),
                                                    control: (styles, state) => ({
                                                        ...styles,
                                                        backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                        borderStyle: "none",
                                                        boxShadow: "none",
                                                        borderRadius: "10px",
                                                        maxHeight: state.isFocused ? "auto" : "30px"
                                                    }),
                                                    indicatorSeparator: (styles) => ({
                                                        ...styles,
                                                        width: "0px",
                                                        minHeight: "20px"
                                                    }),
                                                    valueContainer: (styles, state) => ({
                                                        ...styles,
                                                        maxHeight: isFocusedPartner ? "auto" : "30px"
                                                    })
                                                }}
                                            />
                                            <Select
                                                className="basic-single select-search-facility"
                                                classNamePrefix="select"
                                                value={fileTypeFilter?.filter(i => i.value === searchFormik.values?.file_type)}
                                                name="file_type "
                                                options={fileTypeFilter}
                                                onChange={(e) => { searchFormik.setFieldValue('file_type', e?.value) }}
                                                placeholder="File Type"
                                                isClearable
                                                styles={{
                                                    container: (styles) => ({
                                                        ...styles,
                                                        borderRadius: "9px",
                                                        width: '150px',
                                                    }),
                                                    placeholder: (styles) => ({
                                                        ...styles,
                                                        fontSize: '17px'
                                                    }),
                                                    control: (styles, state) => ({
                                                        ...styles,
                                                        backgroundColor: "hsl(204deg 33.33% 97.06%)",
                                                        borderStyle: "none",
                                                        boxShadow: "none",
                                                        borderRadius: "10px",
                                                        maxHeight: state.isFocused ? "auto" : "30px"
                                                    }),
                                                    indicatorSeparator: (styles) => ({
                                                        ...styles,
                                                        width: "0px",
                                                        minHeight: "20px"
                                                    }),
                                                    valueContainer: (styles, state) => ({
                                                        ...styles,
                                                        maxHeight: "30px"
                                                    })
                                                }}
                                            />

                                            <div style={{ width: '227px' }}>

                                                <DateRangePickerComponent
                                                    tooltip="Upload Date "
                                                    name="upload_date_range"
                                                    handleChange={searchFormik.setFieldValue}
                                                    error={searchFormik.errors.upload_date_range}
                                                    touched={searchFormik.touched.upload_date_range}
                                                />
                                            </div>

                                            <div style={{ width: '227px' }}>
                                                <Tooltip title="Received Date" placement="top" disableInteractive>
                                                    <Stack direction="column" spacing={8} alignItems="flex-start">
                                                        <DateRangePicker
                                                            ranges={predefinedBottomRanges}
                                                            cleanable={true}
                                                            placement='auto'
                                                            defaultCalendarValue={[new Date().setHours(0, 0, 0, 0), new Date().setHours(23, 59, 59, 59)]}
                                                            appearance="default"
                                                            format={"MM/dd/yyyy HH:mm"}
                                                            placeholder={"MM/DD/YYYY - MM/DD/YYYY"}
                                                            className="form-date-control form-control-solid b-r-1 text-dark jobmonitor-datepicker"
                                                            name="received_date_range"
                                                            onChange={(value) => handleOnDateTimeChange({ name: "received_date_range", value })}
                                                        />
                                                    </Stack>
                                                </Tooltip>
                                            </div>



                                        </FilterComponent>

                                    </div>
                                </div>


                                <div className="card-body" style={{ padding: "0px 2.25rem" }}>
                                    <div className="table-responsive">
                                        <div className="dashboardtable">
                                            <DataTable
                                                key={searchKeyForTable}
                                                className="custom-datatable"
                                                fixedHeader={true}
                                                data={data?.results?.data}
                                                columns={columns}
                                                onColumnOrderChange={handleColumnOrderChange}
                                                persistColumnOrder={true}
                                                progressPending={loading}
                                                pagination
                                                paginationServer
                                                highlightOnHover
                                                paginationTotalRows={totalRows}
                                                paginationPerPage={limit}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                onChangeRowsPerPage={handlePerRowsChange}
                                                onChangePage={handlePageChange}
                                                conditionalRowStyles={conditionalRowStyles}
                                                onRowClicked={handleRowCheckClick}
                                                theme="solarized"
                                                customStyles={queueDatatableCustomStyles}
                                                sortServer={true}
                                                onSort={handleSort}
                                            />

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </React.Fragment>
    )
}

export default List837LockBox
